import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  facilityMetadata: {
    id: 'screens.HubScreen.components.MessageDetails.facilityMetadata',
    defaultMessage: 'Facility: {facility}',
  },
  groupsMetadata: {
    id: 'screens.HubScreen.components.MessageDetails.groupsMetadata',
    defaultMessage: 'Groups: {groups}',
  },
  broadcast: {
    id: 'screens.HubScreen.components.MessageDetails.broadcast',
    defaultMessage: 'Broadcast message',
  },
  retries: {
    id: 'screens.HubScreen.components.MessageDetails.retries',
    defaultMessage: 'Message was retried {label}:',
  },
  secure: {
    id: 'screens.HubScreen.components.MessageDetails.secure',
    defaultMessage: 'Secure Chat',
  },
  sentTo: {
    id: 'screens.HubScreen.components.MessageDetails.sentTo',
    defaultMessage: 'Sent to {to}',
  },
  voice: {
    id: 'screens.HubScreen.components.MessageDetails.voice',
    defaultMessage: 'Voice',
  },
  email: {
    id: 'screens.HubScreen.components.MessageDetails.email',
    defaultMessage: 'Email',
  },
  whatsapp: {
    id: 'screens.HubScreen.components.MessageDetails.whatsapp',
    defaultMessage: 'WhatsApp',
  },
  sms: {
    id: 'screens.HubScreen.components.MessageDetails.sms',
    defaultMessage: 'SMS',
  },
  andMessage: {
    id: 'screens.HubScreen.components.MessageDetails.and',
    defaultMessage: 'and',
  },
});
